module.exports = __webpack_public_path__ + "img/addgroup.2537a054.svg";